import axios from "./axios";

class Routes {
  async homepage() {
    const response = await axios.get(`/homepage`);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }
}

export default new Routes();
